export enum BannerType {
  Home = 0,
  Category = 1,
  Store = 2,
  Promotional = 3,
  App = 4,
}

export enum BannerPosition {
  Top = 0,
  Middle = 1,
  Bottom = 2,
  Sidebar = 3,
}

export interface BannerDto {
  id: number;
  title: string;
  subtitle?: string;
  imageUrl: string;
  mobileImageUrl?: string;
  linkUrl?: string;
  type: BannerType;
  typeText: string;
  position: BannerPosition;
  positionText: string;
  displayOrder: number;
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  storeId?: number;
  categoryId?: number;
  backgroundColor?: string;
  textColor?: string;
  createdAt: string;
}

export interface BannerFilterParams {
  type?: BannerType;
  position?: BannerPosition;
  activeOnly?: boolean;
  storeId?: number;
  categoryId?: number;
  page?: number;
  pageSize?: number;
}

export interface BannerCreateDto {
  title: string;
  subtitle?: string;
  imageUrl: string;
  mobileImageUrl?: string;
  linkUrl?: string;
  type: BannerType;
  position: BannerPosition;
  displayOrder?: number;
  startDate?: string;
  endDate?: string;
  isActive?: boolean;
  storeId?: number;
  categoryId?: number;
  backgroundColor?: string;
  textColor?: string;
}

export type BannerUpdateDto = BannerCreateDto;
